import React, { useState } from "react";
import EditScoresDialog from "./EditScoresDialog";
import SportChart from "./SportChart";
import SportTable from "./SportTable";
import { InputSwitch } from "primereact/inputswitch";
import { InputNumber } from "primereact/inputnumber";

export default function Sport({ sports, selectedSport, results, setResults }) {
  const [editDialog, setEditDialog] = useState(false);
  const [roundToEdit, setRoundToEdit] = useState(0);
  const [participantToEdit, setParticipantToEdit] = useState(0);

  if (!results.sports[selectedSport]) {
    return null;
  }

  const sport = results.sports[selectedSport];

  // Function to normalize rounds, including tie-breaking rounds
  function normalizeRounds(rounds) {
    const totalRounds = sport.rounds + (sport.tieBreakingRounds || 0);
    const arr = rounds ? [...rounds] : [];
    arr.length = totalRounds;
    for (let i = 0; i < totalRounds; i++) {
      if (arr[i] == null) arr[i] = 0;
    }
    return arr;
  }

  // Prepare participant scores & best round logic
  const participantScores = results.participants.map(({ id, name }) => {
    const entry = sport.results.find((r) => r.id === id);
    const rounds = normalizeRounds(entry?.results);

    const mainRounds = rounds.slice(0, sport.rounds); // only main rounds
    let score,
      bestRoundIndex = null;

    if (sport.combined) {
      score = mainRounds.reduce((a, b) => a + b, 0);
    } else {
      if (sport.ascending) {
        score = Math.min(...mainRounds);
      } else {
        score = Math.max(...mainRounds);
      }
      bestRoundIndex = mainRounds.indexOf(score);
    }

    return { id, name, rounds, score, bestRoundIndex };
  });

  return (
    <div>
      <SportChart sport={sport} participantScores={participantScores} />
      <SportTable
        sport={sport}
        participantScores={participantScores}
        setEditDialog={setEditDialog}
        setParticipantToEdit={setParticipantToEdit}
        setRoundToEdit={setRoundToEdit}
        editable={!results.sports[selectedSport].completed}
      />

      <div style={{ display: 'table', width: '400px', marginTop: '1rem' }}>
        {/* Row: Completed */}
        <div style={{ display: 'table-row' }}>
          <div style={{ display: 'table-cell', padding: '0.5rem', verticalAlign: 'middle' }}>
            <label htmlFor="completed">Valmis</label>
          </div>
          <div style={{ display: 'table-cell', padding: '0.5rem' }}>
            <InputSwitch
              inputId="completed"
              checked={results.sports[selectedSport].completed || false}
              onChange={(e) => {
                const newResults = {
                  ...results,
                  sports: results.sports.map((sport, idx) =>
                    idx === selectedSport ? { ...sport, completed: e.value } : sport
                  ),
                };
                setResults(newResults);
              }}
              className="p-inputswitch-sm"
            />
          </div>
        </div>

        {/* Row: Tiebreaking Rounds */}
        {!results.sports[selectedSport].completed && <div style={{ display: 'table-row' }}>
          <div style={{ display: 'table-cell', padding: '0.5rem', verticalAlign: 'middle' }}>
            <label htmlFor="tieBreakingRounds">Tasoittavat kierrokset</label>
          </div>
          <div style={{ display: 'table-cell', padding: '0.5rem' }}>
            <InputNumber
              inputId="tieBreakingRounds"
              value={results.sports[selectedSport].tieBreakingRounds || 0}
              onValueChange={(e) => {
                const newResults = { ...results };
                newResults.sports[selectedSport].tieBreakingRounds = e.value || 0;
                setResults(newResults);
              }}
              showButtons
              buttonLayout="horizontal"
              decrementButtonClassName="p-button-outlined p-button-sm"
              incrementButtonClassName="p-button-outlined p-button-sm"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
              min={0}
              className="p-inputnumber-sm"
              inputStyle={{ width: '2.5rem', textAlign: 'center' }}
              style={{ maxWidth: 'fit-content' }}
              inputRef={(el) => {
                if (el) el.readOnly = true; // ✅ only the text box is readonly
              }}
            />
          </div>
        </div>}
      </div>



      <EditScoresDialog
        results={results}
        selectedSport={selectedSport}
        visible={editDialog}
        onHide={() => setEditDialog(false)}
        onChange={setResults}
        round={roundToEdit}
        participantToEdit={participantToEdit}
        setParticipantToEdit={setParticipantToEdit}
      />
    </div>
  );
}
